export enum CuttingToolType {
	Bullnose = 0,
	Ballnose = 10,
	Endmill = 20,
	Drill = 30,
	Spot = 40,
	Tap = 50,
	Ream = 60,
	UDrill = 70,
	Chamfer = 80,
	CarbideDrill = 90,
	Moldino = 100
}
